import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getCategory } from "../../service/Category/categoryService";
 
// interface Category {
//   id: number;
//   name: string;
//   icon: string;
 
// }
 
interface CategoryState {
  categories: any[];
  loading: boolean;
  error: string | null;
  selectedState: string;
}
 
const initialState: CategoryState = {
  categories: [],
  loading: false,
  error: null,
  selectedState: "",
};
// const transformCategories = (data: any): any => {
//     return {
//       ...data,
//       // id: data.id,
//       children: data.categories? data.categories.map(transformCategories) : undefined,
//     };
//   };
export const fetchcategory = createAsyncThunk<any[], void, { rejectValue: string }>(
  "category/fetchcategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCategory();
      // console.log(response.data);
      // let formattedData =response.data.data.length > 0 ? response.data.data.map((e)=>(transformCategories(e))):[];
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch states");
    }
  }
);
 
const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategoryState: (state, action: PayloadAction<string>) => {
      state.selectedState = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchcategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchcategory.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.categories = action.payload;  
      })
      .addCase(fetchcategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});
 
export const { setCategoryState } = categorySlice.actions;
export default categorySlice.reducer;